module.exports = [{
      plugin: require('/Users/kevindavis/Projects/kevindavi5dotcom/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
